// extracted by mini-css-extract-plugin
export default {"root":"Template_root__07bzN","header":"Template_header__27dL+","banner":"Template_banner__dePDv","stack":"Template_stack__hzm4H","content":"Template_content__jhDZe"};